module.exports = "/_next/static/images/fire-37426e645cc2b3484599db57af44cf50.gif";